import React from 'react'
import useExpandingStrengths from './hooks/useExpandingStrengths'
import s from './styles/ExpandingStrengths.module.scss'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow_short_right.svg'

const ExpandingStrengths = ({
	rows = [],
	hasTraitScores = true,
	isLoading = false,
}) => {
	const vm = useExpandingStrengths(rows)

	return (
		<section className={s.card} aria-label="Expanding strengths">
			<div className={s.head}>
				<h3 className={s.head__title}>Expanding Strengths</h3>
				<span className={s.head__meta}>Top 10 Attributes</span>
			</div>

			{vm.rows.length === 0 ? (
				<p className={s.empty}>
					{hasTraitScores
						? 'No expanding strengths available yet.'
						: 'This student has no saved trait scores.'}
				</p>
			) : (
				<div className={s.list}>
					{vm.rows.map(row => {
						const isOpen = vm.openDims.has(row.dim)

						return (
							<div
								key={row.dim}
								className={`${s.item} ${isOpen ? s.itemOpen : ''}`}
							>
								<button
									type="button"
									className={s.trigger}
									onClick={() => {
										if (isLoading) return
										vm.toggleDim(row.dim)
									}}
									aria-expanded={isOpen}
									disabled={isLoading}
								>
									<div className={s.main}>
										<div className={s.row}>
											<span className={s.row__title}>{row.archetypeName}</span>
											<span className={s.row__arrow}>
												<ArrowIcon />
											</span>
										</div>
										<div className={s.progress}>
											<div className={s.track}>
												<div
													className={s.fill}
													style={{ width: `${row.percent}%` }}
												/>
											</div>
											<span className={s.percent}>{row.percent}%</span>
										</div>
									</div>
								</button>

								{isOpen && !isLoading ? (
									<div className={s.detail}>
										<p className={s.detail__text}>{row.archetypeBlurb}</p>
										<div className={s.tags}>
											{row.tags.map(tag => (
												<span key={tag} className={s.tag}>
													{tag}
												</span>
											))}
										</div>
									</div>
								) : null}
							</div>
						)
					})}
				</div>
			)}
		</section>
	)
}

export default ExpandingStrengths
